<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>

        <!-- Fila de filtros debajo del título a la izquierda -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <b-form-select
                        id="report-select"
                        v-model="fecha"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectReport }}
                        </b-form-select-option>
                        <option v-for="item in lstFechaCierre" :key="item.id" :value="item.fecha_cierre">
                            {{ item.fecha_cierre }}
                        </option>
                    </b-form-select>
                    
                    <b-button
                        class="consult-btn ml-2"
                        @click="consulReportPorTercero()"
                        :disabled="!fecha"
                    >
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                    </b-button>
                </div>
            </div>
        </div>

        <div class="admin-table-block mt-4">
            <div v-if="!isLoading">
                <CorporateDataTable
                    :items="lstReporTercero"
                    :fields="allFields"
                    :labels="tableLabels"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="showSearchTable"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="tableFilterDefs"
                    :toolbar-disabled="!showToolbarExtras"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                size="sm"
                                class="table-toolbar-excel-btn"
                                @click="genReportePorTercero()"
                                :disabled="!showToolbarExtras || lstReporTercero.length === 0"
                            >
                                <font-awesome-icon :icon="['fas', 'file-excel']" class="mr-1" />
                            </b-button>
                        </div>
                    </template>

                    <template #cell(total_valor_canon)="data">
                        <div class="text-end">{{ formatNumber(data.item?.total_valor_canon) }}</div> 
                    </template>
                    <template #cell(pasivo_inicial)="data">
                        <div class="text-end">{{ formatNumber(data.item?.pasivo_inicial) }}</div> 
                    </template>
                    <template #cell(total_cambio_pasivo)="data">
                        <div class="text-end">{{ formatNumber(data.item?.total_cambio_pasivo) }}</div> 
                    </template>
                    <template #cell(total_pago_capital)="data">
                        <div class="text-end">{{ formatNumber(data.item?.total_pago_capital) }}</div> 
                    </template>
                    <template #cell(total_intereses)="data">
                        <div class="text-end">{{ formatNumber(data.item?.total_intereses) }}</div> 
                    </template>
                    <template #cell(pasivo_final)="data">
                        <div class="text-end">{{ formatNumber(data.item?.pasivo_final) }}</div> 
                    </template>
                    <template #cell(activo_derecho_uso_bruto)="data">
                        <div class="text-end">{{ formatNumber(data.item?.activo_derecho_uso_bruto) }}</div> 
                    </template>
                    <template #cell(total_gasto_amortizacion)="data">
                        <div class="text-end">{{ formatNumber(data.item?.total_gasto_amortizacion) }}</div> 
                    </template>
                    <template #cell(amortizacion_acumulada)="data">
                        <div class="text-end">{{ formatNumber(data.item?.amortizacion_acumulada) }}</div> 
                    </template>
                </CorporateDataTable>
            </div>

            <!-- Spinner de carga -->
            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import ContratoCierre from '../../services/ContratoCierre'; 
import Reportes from '../../services/Reportes'; 
import Authentication from "../../services/Authentication"; 
import CorporateDataTable from '../utils/CorporateDataTable.vue';
import * as XLSX from "exceljs";

export default {
    name : 'ReportePorTercero',
    components : {CorporateDataTable},
    data : () => ({
        fecha : '',
        nameCompania: '',
        lstReporTercero : [],
        lstFechaCierre : [],
        isLoading : false,
        perPage: 500,
        currentPage: 1,
        showToolbarExtras: false,
        fields: [
            { key: 'identificacion', label: 'Nit', sortable: false },
            { key: 'nombre', label: 'Arrendador', sortable: false },
            { key: 'cantidad', label: 'Cantidad', sortable: false },
            { key: 'total_valor_canon', label: 'Total valor canon', sortable: false },
            { key: 'pasivo_inicial', label: 'Pasivo inicial', sortable: false },
            { key: 'total_cambio_pasivo', label: 'Total cambio pasivo', sortable: false },
            { key: 'total_pago_capital', label: 'Total pago capital', sortable: false },
            { key: 'total_intereses', label: 'Total intereses', sortable: false },
            { key: 'pasivo_final', label: 'Pasivo final', sortable: false },
            { key: 'activo_derecho_uso_bruto', label: 'Activo derecho uso bruto', sortable: false },
            { key: 'total_gasto_amortizacion', label: 'Total gasto amortización', sortable: false },
            { key: 'amortizacion_acumulada', label: 'Amortización acumulada', sortable: false },
        ]
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Reporte por tercero',
                    fecha : 'Fecha:',
                    consultar : 'Consultar',
                    selectReport : 'Seleccione Fecha',
                    nit : 'Nit',
                    arrendador : 'Arrendador',
                    cantidad : 'Cantidad',
                    totValorCanon : 'Total valor canon',
                    pasivoInicial : 'Pasivo inicial',
                    totCambioPasiv : 'Total cambio pasivo',
                    totPagoCapital : 'Total pago capital',
                    totIntereses : 'Total intereses',
                    pasivoFin : 'Pasivo final',
                    actiDerUsoBrt : 'Activo derecho uso bruto',
                    totGastoAmort : 'Total gasto amortización',
                    amortAcumulada : 'Amortización acumulada',
                    seleccion : 'Seleccione...',
                    filterNit : 'Filtrar nit...', 
                    filterArrendador : 'Filtrar arrendador...', 
                    filterCantidad: 'Filtrar cantidad...', 
                    filterTotValCanon : 'Filtrar total valor canon...', 
                    filterPasivoIni : 'Filtrar pasivo inicial...', 
                    filterTotCambPasivo : 'Filtrar total cambio pasivo...', 
                    filterTotPagoCap : 'Filtrar total pago capital...', 
                    filterTotInteres : 'Filtrar total intereses...', 
                    filterPasivFinal : 'Filtrar pasivo final...',
                    filterActDerUsoBrt : 'Filtrar activo derecho uso bruto...', 
                    filterTotGastAmort : 'Filtrar total gasto amortización...',
                    filterAmortAcumulad : 'Filtrar amortización acumulada...',
                    loading: 'Cargando...',
                    noData: 'No hay datos disponibles',
                    noMatches: 'No se encontraron resultados',
                    searchPlaceholder: 'Buscar en la tabla...',
                    rowsPerPage: 'Filas por página:',
                    noSort: 'Sin orden',
                    sortAsc: 'A-Z / Menor a mayor',
                    sortDesc: 'Z-A / Mayor a menor',
                    columns: 'Columnas',
                    showAllColumns: 'Mostrar todas',
                    filters: 'Filtros',
                    clearFilters: 'Limpiar filtros'
                }
            }else{
                return {
                    title : 'Third party report',
                    fecha : 'Date:',
                    consultar : 'Consult',
                    selectReport : 'Select Date',
                    nit : 'Nit',
                    arrendador : 'Lessor',
                    cantidad : 'Quantity',
                    totValorCanon : 'Total canon value',
                    pasivoInicial : 'Initial liabilities',
                    totCambioPasiv : 'Total passive change',
                    totPagoCapital : 'Total capital payment',
                    totIntereses : 'Total interests',
                    pasivoFin : 'Final passive',
                    actiDerUsoBrt : 'Asset right gross use',
                    totGastoAmort : 'Total amortization expense',
                    amortAcumulada : 'Accumulated amortization',
                    seleccion : 'Select...',
                    filterNit : 'Filter nit...', 
                    filterArrendador : 'Filter landlord...', 
                    filterCantidad : 'Filter quantity...', 
                    filterTotValCanon : 'Filter by total lease value...', 
                    filterPasivoIni : 'Filter initial passive...', 
                    filterTotCambPasivo : 'Filter total passive change...', 
                    filterTotPagoCap : 'Filter total principal payment...', 
                    filterTotInteres : 'Filter total interest...', 
                    filterPasivFinal : 'Filter final passive...',
                    filterActDerUsoBrt : 'Filter active gross right-of-use...', 
                    filterTotGastAmort : 'Filter total amortization expense...',
                    filterAmortAcumulad : 'Filter accumulated amortization...',
                    loading: 'Loading...',
                    noData: 'No data available',
                    noMatches: 'No results found',
                    searchPlaceholder: 'Search in table...',
                    rowsPerPage: 'Rows per page:',
                    noSort: 'No sorting',
                    sortAsc: 'A-Z / Low to high',
                    sortDesc: 'Z-A / High to low',
                    columns: 'Columns',
                    showAllColumns: 'Show all',
                    filters: 'Filters',
                    clearFilters: 'Clear filters'
                }
            }
        },
        allFields() {
            return [
                { key: 'identificacion', label: this.labels.nit, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'nombre', label: this.labels.arrendador, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '300px' } },
                { key: 'cantidad', label: this.labels.cantidad, sortable: true, thClass: 'text-left', tdClass: 'text-center align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'total_valor_canon', label: this.labels.totValorCanon, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'pasivo_inicial', label: this.labels.pasivoInicial, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'total_cambio_pasivo', label: this.labels.totCambioPasiv, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'total_pago_capital', label: this.labels.totPagoCapital, sortable: true, thClass: 'text-center', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'total_intereses', label: this.labels.totIntereses, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'pasivo_final', label: this.labels.pasivoFin, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'activo_derecho_uso_bruto', label: this.labels.actiDerUsoBrt, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'total_gasto_amortizacion', label: this.labels.totGastoAmort, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } },
                { key: 'amortizacion_acumulada', label: this.labels.amortAcumulada, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '120px' } }
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'identificacion', type: 'text', placeholder: this.labels.filterNit },
                { key: 'nombre', type: 'text', placeholder: this.labels.filterArrendador },
                { key: 'cantidad', type: 'text', placeholder: this.labels.filterCantidad },
                { key: 'total_valor_canon', type: 'text', placeholder: this.labels.filterTotValCanon },
                { key: 'pasivo_inicial', type: 'text', placeholder: this.labels.filterPasivoIni },
                { key: 'total_cambio_pasivo', type: 'text', placeholder: this.labels.filterTotCambPasivo },
                { key: 'total_pago_capital', type: 'text', placeholder: this.labels.filterTotPagoCap },
                { key: 'total_intereses', type: 'text', placeholder: this.labels.filterTotInteres },
                { key: 'pasivo_final', type: 'text', placeholder: this.labels.filterPasivFinal },
                { key: 'activo_derecho_uso_bruto', type: 'text', placeholder: this.labels.filterActDerUsoBrt },
                { key: 'total_gasto_amortizacion', type: 'text', placeholder: this.labels.filterTotGastAmort },
                { key: 'amortizacion_acumulada', type: 'text', placeholder: this.labels.filterAmortAcumulad },
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        showSearchTable() {
            return true
        }
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        consulReportPorTercero(){
            if(this.fecha == ''){ 
                this.$toast.error('Diligenciar la fecha.') 
            }else{
                this.isLoading = true
                Reportes.generaReportePorTercero(this.fecha) 
                .then((res) => { 
                    this.lstReporTercero = res.data.lstReporTercero 
                    this.showToolbarExtras = true
                    if(this.lstReporTercero.length == 0){ 
                        this.$toast.info('No hay datos para la fecha seleccionada.') 
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error('Error al consultar los datos')
                    this.lstReporTercero = []
                    this.showToolbarExtras = false
                })
                .finally(() => {
                    this.isLoading = false
                })
            }
        },
        async genReportePorTercero(){
            if (this.lstReporTercero.length === 0) {
                this.$toast.error('No hay datos para exportar.')
                return
            }

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Reporte por tercero "+this.fecha) 

            const titulo = ["Reporte por tercero "+this.fecha] 
            worksheet.addRow(titulo) 
            worksheet.mergeCells('A1:L1') 
            worksheet.getCell('A1').font = { name: 'Arial', bold : true, size : 12}; 
            worksheet.getCell('A1').alignment = { horizontal : 'center'}; 

            // =======================
            // FILA 2
            // =======================
            worksheet.addRow(['']); 
            worksheet.mergeCells('A2:L2'); 

            const cell2 = worksheet.getCell('A2'); 

            cell2.value = { 
                richText: [
                    { text: 'Generado por: ', font: { bold: true } },
                    { text: `${this.$store.state.userName} | ` }, 

                    { text: 'Fecha generación: ', font: { bold: true } },
                    { text: `${this.fechaActual()} | ` }, 

                    { text: 'Compañía: ', font: { bold: true } },
                    { text: `${this.nameCompania}` }, 
                ]
            };

            cell2.font = { name: 'Arial', size: 12 }; 
            cell2.alignment = { horizontal: 'center', vertical: 'middle' }; 

            worksheet.addRow(['']); 
            worksheet.mergeCells('A3:L3') 

            const tituloCelda = [
                'Nit',
                'Nombre',
                'Cantidad',
                'Total valor canon',
                'Pasivo inicial',
                'Total cambio pasivo',
                'Total pago capital',
                'Total intereses',
                'Pasivo final',
                'Activo derecho uso bruto',
                'Total gasto amortización',
                'Amortización acumulada'
            ]

            const headerRow = worksheet.addRow(tituloCelda) 
            headerRow.font = { name: 'Arial', bold: true, size: 12 }; 
            headerRow.alignment = { horizontal: 'center' } 

            this.lstReporTercero.map((e) => { 
                worksheet.addRow([ 
                    e.identificacion, 
                    e.nombre, 
                    e.cantidad, 
                    this.formatNumber(e.total_valor_canon), 
                    this.formatNumber(e.pasivo_inicial), 
                    this.formatNumber(e.total_cambio_pasivo), 
                    this.formatNumber(e.total_pago_capital), 
                    this.formatNumber(e.total_intereses), 
                    this.formatNumber(e.pasivo_final), 
                    this.formatNumber(e.activo_derecho_uso_bruto), 
                    this.formatNumber(e.total_gasto_amortizacion), 
                    this.formatNumber(e.amortizacion_acumulada), 
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }

            for( let row = 1; row <= worksheet.rowCount; row++){ 
                if ([1, 2, 3].includes(row)) continue; // 👈 omitir filas 
                for( let col = 1; col <= worksheet.columnCount; col++){ 
                    worksheet.getCell(row, col).border = border; 
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer() 
            const downloadLink = document.createElement("a") 
            downloadLink.download = "Reporte por tercero.xlsx" 
            downloadLink.href = window.URL.createObjectURL( 
                new Blob([file], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
                })
            )

            downloadLink.style.display = "none"; 

            document.body.appendChild(downloadLink); 
            downloadLink.click(); 

            downloadLink.remove(); 
            
            this.$toast.success('Reporte exportado exitosamente')
        },
        formatNumber(value) {
            if (value === null || value === undefined) return '0'
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 })?.format(value); 
        },
        fechaActual(){
            const fecha = new Date()

            const año = fecha.getFullYear() 
            const mes = String(fecha.getMonth() + 1).padStart(2, '0') // getMonth() va de 0 a 11 
            const dia = String(fecha.getDate()).padStart(2, '0') 

            return `${año}-${mes}-${dia}`
        },
    },
    mounted(){
        this.isLoading = true
        Promise.all([
            ContratoCierre.getListadoFechas(),
            Authentication.leaParametros()
        ])
        .then(([fechasRes, authRes]) => {
            this.lstFechaCierre = fechasRes.data.lstFechaCierre || []
            this.nameCompania = authRes.data.parametros?.compania || ''
        })
        .catch((err) => {
            console.log(err)
            this.$toast.error('Error al cargar los datos iniciales')
        })
        .finally(() => {
            this.isLoading = false
        })
    },
    watch:{
        fecha(val){
            if(val == ""){
                this.lstReporTercero = []
                this.showToolbarExtras = false
            }
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* Estilos para el contenedor de filtros - ahora a la izquierda */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

/* Para que el texto de las opciones se vea completo */
.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover,
.niif-header .consult-btn:focus,
.niif-header .consult-btn:active,
.niif-header .consult-btn:not(:disabled):hover,
.niif-header .consult-btn:not(:disabled):focus,
.niif-header .consult-btn:not(:disabled):active {
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
    box-shadow: none !important;
}

.niif-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
}

/* Estilos para la flecha y título */
.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

.niif-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

.table-toolbar-excel-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #016690;
    color: white;
    border: 1px solid #085170;
}

.table-toolbar-excel-btn:hover:not(:disabled) {
    background-color: #085170;
    border-color: #0e3a4d;
}

.table-toolbar-excel-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* Ajustes responsivos */
@media (max-width: 1200px) {
    .niif-header .filter-select {
        min-width: 160px;
        max-width: 220px;
        height: 36px;
        font-size: 13px;
    }
    
    .niif-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 992px) {
    .niif-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        margin-left: 0 !important;
        justify-content: flex-start;
        gap: 6px;
    }
    
    .niif-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }
    
    .niif-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }
    
    .niif-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }
    
    .niif-header .filters-container {
        gap: 4px;
    }
    
    .niif-header .consult-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
    }
}
</style>